// compare-plans.styled.ts
import styled from "@emotion/styled";
import { COLORS } from "../../../header/header.styled";
import {
    MutedText as BaseMutedText,
    SubTitle as BaseSubTitle,
    Title as BaseTitle,
} from "../../account/account-settings.styled";
import { Badge } from "../modals/upgrade-now/upgrade-now.styled";

export const ComparePlansWrapper = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Footer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PlanCard = styled.div<{ $highlight?: boolean }>`
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: ${({ $highlight }) =>
        $highlight ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.03)"};
    border-radius: 12px;
    padding: 16px;
`;

export const BulletItem = styled.li`
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
    line-height: 1.4;
    color: ${COLORS.textMuted};

    &::before {
        content: "";
        display: inline-block;
        background-image: url("/checkmark.svg");
        background-size: contain;
        background-repeat: no-repeat;
        width: 16px;
        height: 16px;
        margin-right: 8px;
        margin-top: 4px;
        flex-shrink: 0;
    }

    &:last-child {
        margin-bottom: 0;
    }
`;

export const PlanHeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const BestValueBadge = styled(Badge)`
    border: 1px solid #5e84ed;
    border-radius: 12px;
    color: #5e84ed;
    width: 92px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PricingMutedText = styled(BaseMutedText)`
    font-weight: 400;
    font-size: 14px;
    line-height: 1.4;
`;

export const PricingMutedLabel = styled(BaseMutedText)`
    font-weight: 600;
    font-size: 14px;
`;

export const SavingSubTitle = styled(BaseSubTitle)`
    font-weight: 600;
    font-size: 14px;
    color: #8fb0ff;
`;

export const UpsellTitle = styled(BaseTitle)`
    font-weight: 700;
    font-size: 15px;
`;
